const config = {
    id: 18,
    name: "锚点",
    type: 1,
    module_code: "anchor",
    icon: "icon-tms-bottom_nav",
    font_icon: "&#xe78b;",
    style_type: 1,
    link_type: 0,
    property_data: {
        anchor_name: "test"
    }
};
export default config;